<script setup lang="ts">
import GaiaText from '../../base/GaiaText.vue';
import { gaiaNeutral, gaiaStatus } from '../../themes/tokens';

const props = defineProps({
  title: {
    type: String,
    default: "We couldn't sort this file",
  },
});

const surface = gaiaNeutral.surface;
const alertBorder = gaiaStatus.alertBorder;
</script>

<template>
  <!-- The detail pane for a file that did not make it into a contract
       (Contracts Overview mock, "Failed"): an alert-ruled card centred in the
       pane. The default slot is the reason; #actions holds whatever the
       caller can offer about it. -->
  <div class="gaia-intake-failure">
    <div class="card">
      <gaia-text tag="div" size="body" weight="semibold" tone="alert">{{ props.title }}</gaia-text>
      <gaia-text tag="div" size="row" tone="text" class="reason"><slot /></gaia-text>
      <div v-if="$slots.actions" class="actions"><slot name="actions" /></div>
    </div>
  </div>
</template>

<style scoped>
.gaia-intake-failure {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.card {
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 22px 24px;
  background: v-bind(surface);
  border: 1px solid v-bind(alertBorder);
  border-radius: 10px;
}

.reason {
  line-height: 1.5;
  text-wrap: pretty;
}

.actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}
</style>
